import { all, put, takeEvery } from 'redux-saga/effects'
import _ from 'lodash'
import moment from 'moment'

import config from '../../../../../../../../config'

import { BLOCK_DATA_LOADED } from '../../../../../../components/Workspace/components/HocBlock/constants'
import {
    blockSaveCustomData,
    blockDataTransformed,
} from '../../../../../../components/Workspace/components/HocBlock/actions'
import { formatValueByBase, getNumberBase } from '../../../../../../../../components/FormattedNumber/helpers'
import intl from '../../../../../../../../services/translations/intl-saga'

import { BISNODE_SCORING_CHART_TOGGLE_DATA_TABLE } from './components/Chart/constants'

const formatLimitValue = (value, locale, emptyValue = 'N/A') => {
    if (_.isNil(value) || !locale) return emptyValue

    const valueBaseObj = getNumberBase(value)
    const formattedValue = formatValueByBase(value, valueBaseObj?.base, 2, emptyValue)

    if (_.isNil(valueBaseObj?.translate)) return `${formattedValue}`

    // Returns string of formatted value (example: 1.5 mld)
    // See getNumberBase or formatValueByBase functions for more information
    return `${formattedValue} ${intl.formatMessage(locale, `global.${valueBaseObj?.translate}Short`)}`
}

function* onDataLoaded(_action) {
    const blockKey = _.get(_action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.bisnodeScoring.key) return null

    const module = _.get(_action, 'data.module', null)
    const id = _.get(_action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const locale = _.get(_action, 'data.locale', null)
    const data = _action?.data?.data

    const transformedData = {
        summary: {
            data: data?.[0]?.data,
            legend: data?.[0]?.legend,
        },
        chart: {
            data: _.reduce(
                data?.[1]?.scoringProbabilities,
                (acc, val) => [
                    ...acc,
                    {
                        startDate: moment(val?.startDate?.value).format('DD-MM-YYYY'),
                        probability: val?.probability,
                        ratingText: val?.ratingText,
                        minTransactionLimit: formatLimitValue(val?.minTransactionLimit?.amount, locale, null),
                        maxTransactionLimit: formatLimitValue(val?.maxTransactionLimit?.amount, locale, null),
                        minCreditLimit: formatLimitValue(val?.minCreditLimit?.amount, locale, null),
                        maxCreditLimit: formatLimitValue(val?.maxCreditLimit?.amount, locale, null),
                        currency: val?.creditLimit?.currency || val?.transactionLimit?.currency,
                    },
                ],
                []
            ),
        },
        scoringDegrees: data?.[2]?.scoringDegrees,
    }

    yield put(blockDataTransformed(module, id, blockKey, transformedData))

    yield put(
        blockSaveCustomData(module, id, blockKey, {
            chartDataTableActive: false,
            isTerminologyOpen: false,
        })
    )

    return null
}

function* bisnodeScoringChangeCustomData(action) {
    const blockKey = _.get(action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.bisnodeScoring.key) return null

    const module = _.get(action, 'data.module', null)
    const id = _.get(action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const customData = _.get(action, 'data.customData', null)

    yield put(blockSaveCustomData(module, id, blockKey, customData))

    return null
}

export default function* blockTransformSaga() {
    yield all([
        takeEvery(BLOCK_DATA_LOADED, onDataLoaded),
        takeEvery(BISNODE_SCORING_CHART_TOGGLE_DATA_TABLE, bisnodeScoringChangeCustomData),
    ])
}
